<template>
<div class="chapter">
<div class="inner_page">
<p class="imgcenter"><img alt="image" id="img14_1" src="images/img14_1.jpg"/></p>
<p class="caption"><em class="italic">Lee High Road, 1917. (Note the policeman on the left and the police station on the right)</em> <span class="small">London Borough of Lewisham</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07h_LEWISHAM_CHAPTER01.vue?662c6a85